import * as md5 from 'md5';

export function generateUserId(email: string): string {
  return email ? md5(email) : null;
}
